import { useMemo } from 'react'

import { calculateCreditDays, PaddedWrapper } from './AddCostMetrics'
import { Table } from '@base'
import { displayAmount } from '@utils'

const MetricsData = ({ totalPoAmount, pastDelays, totalDays, paymentTermsList = [], supplierList }) => {
	const columns = [
		{ label: 'Name', key: 'heading', mobile: true, align: 'left' },
		{ label: 'Value', key: 'value', mobile: true, align: 'left' },
	]

	const tableData = useMemo(() => {
		let _data = []
		let _pastDelays = parseInt(pastDelays)
		let creditDays = calculateCreditDays(paymentTermsList)
		let orderGivenSupplierDays = supplierList
			?.filter((_i) => _i?.order_given === true)
			?.reduce((acc, item) => (acc = Math.max(item?.expected_transit_time, acc)), 0)
		if (orderGivenSupplierDays === 0) {
			orderGivenSupplierDays = supplierList
				?.filter((_i) => _i?.expected_transit_time)
				.reduce((acc, item) => (acc = Math.max(item?.expected_transit_time, acc)), 0)
		}
		supplierList?.map((item, index) => {
			_data.push({
				heading: `Transit time (${item?.supplier?.organisation_name ?? item?.supplier?.full_name})`,
				value: `${item?.expected_transit_time ?? 0} Days`,
			})
		})
		_data.push(
			{ heading: 'Credit Days', value: `${creditDays ?? 0} Days` },
			{ heading: 'Past Delays', value: `${_pastDelays ?? 0} Days` },
			{ heading: 'Total Days', value: `${(totalDays ?? 0) + (orderGivenSupplierDays ?? 0)} Days` },
			{ heading: 'PO Amount', value: `${displayAmount(totalPoAmount ?? 0)}` }
		)
		return _data
	}, [totalDays, totalPoAmount, paymentTermsList, pastDelays, supplierList])

	return (
		<PaddedWrapper>
			<Table columns={columns} noScroll data={tableData} totalItemCount={5} rowClickable={false} rowsToDisplay={5} hideFooter />
		</PaddedWrapper>
	)
}

export default MetricsData
